export const patienttitles=[
  {
      title:"Mr",value:"Mr"
  },
  {
      title:"Mrs",value:"Mrs"
  },
  {
      title:"Miss",value:"Miss"
  },
  {
      title:"Dr",value:"Dr"
  },
  {
      title:"Rev",value:"Ref"
  },
  {
      title:"Master",value:"Master"
  },
  {
      title:"Baby",value:"Baby"
  },
]